import { logoutAndClearCaches } from "../../../utils/auth";
import { stopPresenting } from "../../../utils/presentation";

import { AppDispatch } from "store/index";

export const onLogout = (presentingSessionIds: string[], dispatch: AppDispatch) => () => {
  // Stop all sessions that the user is presenting in
  for (const sessionId of presentingSessionIds) {
    stopPresenting(sessionId);
  }

  logoutAndClearCaches(dispatch);
};
